import { Flex, useBreakpointValue, Image, Text, Link, Img } from "@chakra-ui/react";
import { Layout } from "@/layout";
import { SEO } from "@/components/SEO";
import { SearchBar, SearchBarMobile } from "@/components/SearchBar";
import { CarouselHeader, CarouselProducts, CarouselPromo } from "components/Carousel";
import { Konduto } from "@/components/Konduto";
import { useLoading } from "@/contexts/LoadingContext";
import { handleProductName } from "@/utils/handleProductName";
import { CarouselProductsMobile } from "@/components/Carousel/CarouselProductsMobile";
import { CarouselPromoMobile } from "@/components/Carousel/CarouselPromoMobile";
import { InitializeNethone } from "@/lib/nethone-utils/Types/Overloads";
import { useEffect, useState } from "react";
import { CarouselHeaderMobile } from "@/components/Carousel/CarouselHeaderMobile";
import { ZapButton } from "@/utils/whatsAppButton";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Home() {
  const { setActionIsLoading } = useLoading();
  setActionIsLoading(false);
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  useEffect(() => {
    return () => {
      InitializeNethone({
        allowedFields: [
          "MenuEmail",
          "FreeSearch",
          "TireWidth",
          "TireSeries",
          "TireRim",
          "BarVehicleBrand",
          "BarVehicleModel",
          "BarVehicleYear",
          "MenuVehicleBrand",
          "MenuVehicleModel",
          "MenuVehicleYear"
        ],
        secretFields: ["MenuPassword"]
      });
    };
  }, []);

  const [isLoading, setIsloading] = useState<boolean>(true);

  // --------simula o loading do skeleton--------
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsloading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      AOS.init({
        once: true,
        duration: 1500
      });
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <SEO
        title="Loja Oficial LingLong | Compre Pneus Online e Receba Super Rápido."
        description="Promoções de pneus LingLong ✓ Menor Custo de Frete ✓ Compra Segura em até 12x."
        path="/"
      >
        <Layout direction="column" mb="0px" mt="0" className={"Layout"}>
          {/* ----BANNER-----*/}
          <CarouselHeader />
          <CarouselHeaderMobile />

          {/* ------BUSCAR------- */}
          <SearchBar loading={isLoading} />
          <SearchBarMobile loading={isLoading} />

          <Flex justifyContent="center" bgColor=" #F1EEEE">
            <CarouselProducts title={"AS MELHORES OFERTAS DE PNEUS"} loading={isLoading} />
            <CarouselProductsMobile title={"AS MELHORES OFERTAS DE PNEUS"} loading={isLoading} />
          </Flex>
          <Flex flexDir={"column"} bgColor={"ll-white.main"} py={"25px"}>
            <Flex
              w={"full"}
              justifyContent={"center"}
              mb={"25px"}
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="700"
            >
              <Img
                display={["none", "flex"]}
                w={"1200px"}
                src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/pix-desktop.png"}
              />
              <Img
                display={["flex", "none"]}
                w={"95%"}
                src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/pix-mobile.png"}
              />
            </Flex>
            <Flex
              justifyContent="center"
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="700"
            >
              {isWideVersion ? <CarouselPromo /> : <CarouselPromoMobile />}
            </Flex>
          </Flex>
        </Layout>
      </SEO>
    </>
  );
}
